'use strict';

var $ = require('jquery');

module.exports = function () {
    function init() {
        setInterval(function () {
            $.get('SessionKeepAlive');
        }, 60000);
    }
    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/utilities/session-keep-alive.js
// module id = 227
// module chunks = 0